import React from 'react';
import { connect } from 'react-redux';

import { IRootState } from '../../../../modules/stores';
import { getFormattedNumber } from '../../../../helpers';

type IConnectProps = ReturnType<typeof mapState>;
interface IProps {
  fieldId: string;
  recordId?: string;
}

const Raw: React.FC<{ value: string }> = ({ value }) => (
  <span style={{ whiteSpace: 'pre-wrap' }}>{value}</span>
);
const WithFieldId: React.FC<IProps & IConnectProps> = ({ cell, field }) => {
  if (isNaN(cell)) return null;

  const value = getFormattedNumber(cell, field.typeOptions);
  if (!value) return null;

  return <Raw value={value}></Raw>;
};

const mapState = ({ core }: IRootState, { recordId, fieldId }: IProps) => ({
  cell: core.recordById[recordId || core.currentRecordId]?.cells[fieldId],
  field: core.fieldById[fieldId],
});

export default {
  Raw: Raw,
  WithFieldId: connect(mapState)(WithFieldId),
};
